import { ComponentType, createElement, lazy } from 'react'

export type TPreloadableComponent<T extends ComponentType<any>> = T & {
  preload: () => Promise<void>
}

export const lazyPreload = <T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
): TPreloadableComponent<T> => {
  let LoadedComponent: T | undefined
  let factoryPromise: Promise<void> | undefined

  const LazyComponent = lazy(factory)

  const load = () =>
    factory().then((module) => {
      LoadedComponent = module.default
    })

  const Component = ((props) =>
    createElement(
      LoadedComponent || LazyComponent,
      props,
    )) as unknown as TPreloadableComponent<T>

  Component.preload = () => {
    factoryPromise = factoryPromise || load()
    return factoryPromise
  }

  return Component
}

/** Triggers preloading of a page component if it exposes a `preload` method. */
export const preloadPage = (
  page?: ComponentType<any> & { preload?: () => Promise<void> },
): void => {
  page?.preload?.()
}
